import PropTypes from 'prop-types';

export const PagesSelectionPagesPropType = PropTypes.shape({
  id: PropTypes.number.isRequired,
  title: PropTypes.string.isRequired,
});
